import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom';
import Header from '../header/Header';

import './thanks.css'

import { storage } from '../firebase';
import { listAll, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

const PurchaseThanks = () => {
  const [auroraUrl, setAuroraUrl] = useState("");
  const params = useParams();

  // E.g. "Aurora_Refract" gets split into ["Aurora", "Refract"]
  const purchasedItems = params.product ? params.product.split('_').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ) : [];

  const hasAurora = purchasedItems.includes('Aurora');
  const hasRefract = purchasedItems.includes('Refract');

  const formattedProduct = purchasedItems.join(' & ');

  useEffect(() => {
    if (hasAurora) {
      fetchAuroraUrl();
    }
  }, [hasAurora]);

  const fetchAuroraUrl = async () => {
    try {
      const downloadUrl = await getDownloadURL(ref(storage, "Aurora.pkg"));
      setAuroraUrl(downloadUrl);
    } catch (error) {
      console.error("Error fetching Aurora URL:", error);
    }
  };

  const refractUrl = "https://storage.googleapis.com/ts-web-5390d.appspot.com/Refract-Installer-Mac-v1.0.30.pkg";

  return (
    <div className='thanks__container'>
      <Header />
      <div className="thanks__ontop">
        <div className="thanks__title">
          Thanks for purchasing
          <br />
          <span style={{ color: '#4C6C57' }}>{formattedProduct}</span>
        </div>

        <div className="thanks__show">
          Here are your downloads
        </div>

        <div className="thanks__downloads">
          {hasAurora && (
            <>
              <div className="thanks__downloadbox">
                <h3>Aurora</h3>
                <p>Mac OS</p>
                <div className="thanks__downloadunderlined">
                  {auroraUrl ? (
                    <a href={auroraUrl} download>Download</a>
                  ) : (
                    <span style={{ fontSize: '0.9rem' }}>Loading Link...</span>
                  )}
                </div>
              </div>
              <div className="thanks__downloadbox">
                <h3>Aurora</h3>
                <p>Windows</p>
                <div className="thanks__comingsoon">
                  Coming Soon!
                </div>
              </div>
            </>
          )}

          {hasRefract && (
            <>
              <div className="thanks__downloadbox">
                <h3>Refract</h3>
                <p>Mac OS</p>
                <div className="thanks__downloadunderlined">
                  <a href={refractUrl} download>Download</a>
                </div>
              </div>
              <div className="thanks__downloadbox">
                <h3>Refract</h3>
                <p>Windows</p>
                <div className="thanks__comingsoon">
                  Coming Soon!
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default PurchaseThanks